@if (messageMaintenanceList !== undefined) {
<table>
    <thead>
        <tr>
            <th tuiTh>Message</th>
            <th tuiTh></th>
        </tr>
    </thead>
    <tbody>
        @for (messageMaintenance of messageMaintenanceList ; track messageMaintenance.id) {
        <app-message-maintenance-row tuiTr [messageMaintenance]="messageMaintenance" [refreshList]="refreshList" />
        }
    </tbody>
</table>
} @else {
<table>
    <thead>
        <tr>
            <th tuiTh>Message</th>
            <th tuiTh></th>
        </tr>
    </thead>
    <tbody>
        <app-message-maintenance-row tuiTr [messageMaintenance]="undefined" [refreshList]="refreshList"
            class="placeholder" />
    </tbody>
</table>
}